import BackgroundBlobs from "./BackgroundBlob";

const BACKGROUND_COLORS = [
  "#fe8900",
  "#ff4777",
  "#4aa8ff",
  "#ffc178",
  "#f185a1",
  "#8fc5f7",
];

function Background() {

  return (
      <BackgroundBlobs
        color={BACKGROUND_COLORS}
        ballCount={6}
        animationSize={10}
        clumpFactor={0.6}
        speed={0.08}
      />
  );
}

export default Background;
